import type {StateCreator} from 'zustand'

export interface DraggingAddCommentButtonSlice {
  draggingAddCommentButton: {
    isDraggingAddCommentButton: boolean
  }
  draggingAddCommentButtonActions: {
    startDraggingAddCommentButton: () => void
    endDraggingAddCommentButton: () => void
  }
}

export const createDraggingAddCommentButtonSlice =
  (): StateCreator<DraggingAddCommentButtonSlice, [['zustand/devtools', never]]> => set => {
    return {
      draggingAddCommentButton: {
        isDraggingAddCommentButton: false,
      },
      draggingAddCommentButtonActions: {
        startDraggingAddCommentButton: () =>
          set(
            () => ({draggingAddCommentButton: {isDraggingAddCommentButton: true}}),
            undefined,
            'startDraggingAddCommentButton',
          ),
        endDraggingAddCommentButton: () =>
          set(
            () => ({draggingAddCommentButton: {isDraggingAddCommentButton: false}}),
            undefined,
            'endDraggingAddCommentButton',
          ),
      },
    }
  }
